module.exports = __webpack_public_path__ + "img/pic_tltw_ewmsy_normal@2x.4aa448dc.png";